import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import './Auth.css';


import { API } from '../config';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/request-password-reset`, { email });
      setSent(true);
      toast.success('Password reset link sent! Check your email.');
    } catch (error) {
      toast.error('Failed to send reset link');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-card card">
            <div className="verification-message">
              <div className="verification-icon">📧</div>
              <h1>Check Your Email</h1>
              <p>If an account exists with {email}, you'll receive a password reset link shortly.</p>
              <Link to="/login" className="btn btn-primary">Back to Login</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page" data-testid="forgot-password-page">
      <div className="auth-container">
        <div className="auth-card card">
          <div className="auth-header">
            <h1>Forgot Password</h1>
            <p>Enter your email to receive a reset link</p>
          </div>

          <form onSubmit={handleSubmit} data-testid="forgot-password-form">
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="email-input"
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary full-width" 
              disabled={loading}
              data-testid="submit-btn"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <div className="auth-footer">
            Remember your password? <Link to="/login">Login here</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
